// extracted by mini-css-extract-plugin
module.exports = {"card":"projects-module--card--1xvin","card__modalHeader":"projects-module--card__modal-header--3YOJn","card__tagEmoji":"projects-module--card__tag--emoji--1JG7S"};